/**
 * ChannelFilterSearchContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled channel filter search container.
 */
const ChannelFilterSearchContainer = styled.div<{ focused?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: ${60 * Screen.widthRatio}px;
  margin-right: ${18 * Screen.widthRatio}px;
  opacity: ${(props) => (props.focused ? 1 : 0.5)};
  &:hover {
    opacity: 1;
  }
`;

export default ChannelFilterSearchContainer;
